import React from "react";

const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const boxStyle = {
  width: "75%",
  background: "#ffffff",
  borderRadius: 10,
  maxHeight: "80vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
};

const headerStyle = {
  padding: "14px 20px",
  borderBottom: "1px solid #e5e7eb",
  background: "#f9fafb",
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
  fontSize: 18,
  fontWeight: 600,
};

const bodyStyle = {
  padding: 20,
  overflowY: "auto",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: 14,
};

const thStyle = {
  position: "sticky",
  top: 0,
  background: "#f3f4f6",
  border: "1px solid #e5e7eb",
  padding: "10px",
  textAlign: "left",
  fontWeight: 600,
};

const tdStyle = {
  border: "1px solid #e5e7eb",
  padding: "8px 10px",
};

const footerStyle = {
  padding: "12px 20px",
  borderTop: "1px solid #e5e7eb",
  display: "flex",
  justifyContent: "flex-end",
  background: "#fafafa",
  borderBottomLeftRadius: 10,
  borderBottomRightRadius: 10,
};

const closeBtnStyle = {
  padding: "8px 18px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
  fontSize: 14,
};

/**
 * Props:
 *  - data : pending bookings array
 *  - onClose : close modal
 *  - onSelectBooking : callback(bookingId)
 */
const PendingListModal = ({ data, onClose, onSelectBooking }) => {
  const handleRowDoubleClick = (row) => {
    if (onSelectBooking) {
      onClose(); // close modal first
      onSelectBooking(row.bookingid); // let BookingForm handle edit
    }
  };

  return (
    <div style={modalStyle}>
      <div style={boxStyle}>
        {/* HEADER */}
        <div style={headerStyle}>Pending Bookings</div>

        {/* BODY */}
        <div style={bodyStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Booking No</th>
                <th style={thStyle}>Reporting Date</th>
                <th style={thStyle}>Duty Type</th>
                <th style={thStyle}>Vehicle Group</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>

            <tbody>
              {data.map((b, index) => (
                <tr
                  key={b.bookingid}
                  onDoubleClick={() => handleRowDoubleClick(b)}
                  title="Double click to open booking"
                  style={{
                    background: index % 2 === 0 ? "#ffffff" : "#f9fafb",
                    cursor: "pointer",
                  }}
                >
                  <td style={tdStyle}>{b.booking_no}</td>
                  <td style={tdStyle}>
                    {b.reporting_date?.substring(0, 10)}
                  </td>
                  <td style={tdStyle}>{b.duty_type}</td>
                  <td style={tdStyle}>{b.vehicle_group || "N/A"}</td>
                  <td style={tdStyle}>{b.booking_status}</td>
                </tr>
              ))}

              {data.length === 0 && (
                <tr>
                  <td
                    colSpan={5}
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                      color: "#6b7280",
                    }}
                  >
                    No pending bookings found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* FOOTER */}
        <div style={footerStyle}>
          <button onClick={onClose} style={closeBtnStyle}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingListModal;
